export default __webpack_public_path__ + "static/02-03-teach-control-screen-abb595d99f9ba1a0a2c35857e32e1976.gif";